import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isChallengesNumber(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.CHALLENGES_NUMBER && typeof label === 'string' && typeof value === 'number';
}
function _formatChallengesNumber(_ref) {
  let {
    field,
    value
  } = _ref;
  return {
    label: field.view.label,
    value
  };
}
export function formatChallengesNumber(submission) {
  if (isChallengesNumber(submission)) {
    return _formatChallengesNumber(submission);
  }
  return undefined;
}
//# sourceMappingURL=challenges-number-preview.js.map